import type { BreadcrumbItem } from '@acme/foundation';
import type { NavigateFunction } from 'react-router-dom';

export const getCreateApplicationBreadcrumbs = (
  navigate: NavigateFunction,
  title?: string | null
): BreadcrumbItem[] => [
  {
    label: 'Главная',
    onClick: () => navigate('/dashboard'),
  },
  {
    label: title || 'Новая заявка',
  },
];
